<script>
	// emoji-picker-element(웹 컴포넌트) 래퍼. 기존 svelte-emoji-selector와 동일하게
	// on:emoji(detail=이모지 문자)를 디스패치 → 호출부는 import만 바꾸면 됨.
	import "emoji-picker-element";
	import { createEventDispatcher } from "svelte";
	import { theme } from "./theme.js";
	import { cn } from "./cn.js";

	let className = "";
	export { className as class };

	const dispatch = createEventDispatcher();
	let open = false;

	const toggle = () => (open = !open);
	const onPick = (e) => {
		// emoji-click detail: { unicode, emoji, skinTone }
		dispatch("emoji", e.detail?.unicode ?? "");
		open = false;
	};
</script>

<div class={cn("emoji-wrap tw-relative tw-inline-block tw-font-sans", className)}>
	<button
		type="button"
		class="tw-inline-flex tw-h-8 tw-w-8 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-md tw-text-base tw-leading-none tw-text-muted-foreground tw-transition-colors hover:tw-bg-muted hover:tw-text-foreground"
		on:click|stopPropagation={toggle}
		aria-label="이모지"
		title="이모지"
	>😊</button>

	{#if open}
		<!-- 바깥 클릭 닫기 -->
		<button
			type="button"
			class="tw-fixed tw-inset-0 tw-z-[1190] tw-cursor-default"
			aria-label="이모지 닫기"
			on:click|stopPropagation={() => (open = false)}
		></button>
		<div class="tw-absolute tw-right-0 tw-z-[1200] tw-mt-1">
			<emoji-picker
				class={$theme}
				data-source="/static/emoji/data.json"
				on:emoji-click={onPick}
			></emoji-picker>
		</div>
	{/if}
</div>

<style>
	/* CSS 커스텀 프로퍼티는 shadow DOM 경계를 넘어 상속 → 픽커 내부까지 --sb 토큰으로 통일.
	   (라이트/다크는 --sb-* 값이 .dark에서 바뀌므로 자동 전환) */
	emoji-picker {
		width: 320px;
		height: 360px;
		--background: hsl(var(--sb-card));
		--border-color: hsl(var(--sb-border));
		--input-border-color: hsl(var(--sb-input));
		--input-background: hsl(var(--sb-background));
		--input-font-color: hsl(var(--sb-foreground));
		--input-placeholder-color: hsl(var(--sb-muted-foreground));
		--category-font-color: hsl(var(--sb-muted-foreground));
		--button-active-background: hsl(var(--sb-muted));
		--button-hover-background: hsl(var(--sb-muted));
		--indicator-color: hsl(var(--sb-primary));
		--outline-color: hsl(var(--sb-ring));
		border-radius: 10px;
		box-shadow: 0 8px 24px rgb(0 0 0 / 0.18);
	}
</style>
